import { useState, useEffect } from "react";
import { getItemsByOrg } from "../../dataApi/getItems";
import { ItemInstance } from "../../types/list";

export const useItemsByList = (listId: string) => {
  const [itemsData, setItemsData] = useState<ItemInstance[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const items = await getItemsByOrg(listId);
      setItemsData(items);
      setLoading(false);
    })();
  }, []);

  return { itemsData, loading };
};
